/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Sorting criteria with active field and direction
 */
export type InventoryListDtoSort = { [key: string]: unknown };
